export const secondToMinutes = (duration, type) => {
  // Hours, minutes and seconds

  let res = ''
  let hrs = 0
  let mins = 0
  let secs = 0
  if (type === 'seconds') {
    hrs = Math.floor(duration / 3600)
    mins = Math.floor((duration % 3600) / 60)
    secs = Math.floor(duration % 60)
  } else if (type === 'minutes') {
    let convertedDuration = Number(duration).toFixed(2).toString().split('.')
    let wholeNum = Number(convertedDuration[0])
    let decimalNum = Number(convertedDuration[1])
    mins = wholeNum < 60 ? wholeNum : wholeNum % 60
    secs = Math.floor(decimalNum * (60 / 100))
    hrs = Math.floor(wholeNum / 60)
  }

  if (mins < 10) {
    mins = '0' + mins
  }

  if (secs < 10) {
    secs = '0' + secs
  }

  return [hrs, mins, secs].join(':')
}
